import { BoxTruckNearbyDriversSort } from '@numeo/types-core'
import { readLocalStorageValue, writeLocalStorageValue } from '@/utils/safeLocalStorage'

/** Per USER, like the board's column layout: the choice follows the person, in the load drawer and in Search Vehicles. */
const storageKeyFor = (userId: string | undefined): string => `boxTruckLoads:nearbyDriversSort:${userId ?? 'anon'}`

/** What Nearby Drivers opens on until the operator picks a sort. */
export const NEARBY_DRIVERS_DEFAULT_SORT = BoxTruckNearbyDriversSort.RECENT

const isNearbyDriversSort = (value: unknown): value is BoxTruckNearbyDriversSort => Object.values(BoxTruckNearbyDriversSort).some((sort) => sort === value)

/** The operator's last sort. A missing, retired or unreadable value opens on the default instead of an empty list. */
export const readNearbyDriversSort = (userId: string | undefined): BoxTruckNearbyDriversSort =>
    readLocalStorageValue(storageKeyFor(userId), NEARBY_DRIVERS_DEFAULT_SORT, (stored) => (isNearbyDriversSort(stored) ? stored : NEARBY_DRIVERS_DEFAULT_SORT))

/** A blocked store only means the next open starts on the default; this open keeps the choice in memory. */
export const writeNearbyDriversSort = (userId: string | undefined, sort: BoxTruckNearbyDriversSort): void => writeLocalStorageValue(storageKeyFor(userId), sort)
